import React from "react";

type DetailRowProps = {
  label: string;
  value: string | number | boolean | null | undefined;
};

const formatValue = (
  value: string | number | boolean | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return String(value);
};

const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  return (
    <div className="flex justify-between gap-4 py-1.5 border-b border-light last:border-b-0">
      <span className="text-sm text-tertiary shrink-0">{label}</span>
      <span className="text-sm text-primary text-right break-all">
        {formatValue(value)}
      </span>
    </div>
  );
};

export default DetailRow;
